import type { OstType } from '@/components/root/details/tabs/alerts/AlertTypeFilter';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type RootAlertState = {
  mainFilters: {
    ostType?: OstType[];
  };
};
const initialState: RootAlertState = {
  mainFilters: {
    ostType: [],
  },
};

export const alertSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    ostTypeChanged: (state, { payload }: PayloadAction<{ ostType: OstType }>) => {
      state.mainFilters.ostType?.push(payload.ostType);
    },
    removeOstType: (state, { payload }: PayloadAction<{ ostType: OstType }>) => {
      state.mainFilters.ostType = state.mainFilters.ostType?.filter(
        (ostType) => ostType !== payload.ostType,
      );
    },
  },
  selectors: {
    ostType: (state) => state.mainFilters.ostType,
  },
});

export const alertsSelectors = alertSlice.selectors;
export const alertsActions = alertSlice.actions;
